<template>
  <div>
    <page-header
      :page="headerPage"
      :actions="headerActions"
      left-side-class="col-xl-8"
      right-side-class="col-xl-4 d-flex align-items-end justify-content-end pb-2"
    />

    <div class="mb-4">
      <q-tab :active-tab="activeTab">
        <q-tab-item
          title="Solicitudes de Libros"
          :tabindex="tabs.Requests"
          @click="setCurrentTab(tabs.Requests)"
        >
        </q-tab-item>
        <q-tab-item
          title="Libros"
          :tabindex="tabs.Books"
          @click="setCurrentTab(tabs.Books)"
        >
        </q-tab-item>
        <q-tab-item
          lazy
          title="Estudiantes con Libros Asignados"
          :tabindex="tabs.StudentsWithBooks"
          @click="setCurrentTab(tabs.StudentsWithBooks)"
        >
          <students-with-books />
        </q-tab-item>
      </q-tab>
    </div>
    <div v-if="isRequestsTab || isBooksTab">
      <filter-manager
        ref="filter"
        v-model="filter.model"
        :filters="filtersHeader"
        class="filter-manager_extended"
        search-container-class="search-btn"
        @center="onCenterChange"
        @municipality="onMunicipalityChange"
        @search="onSearchHandler()"
      />

      <custom-separator class="my-3 custom-separator" :text="separatorText" />

      <div v-if="hasResults">
        <template v-if="isRequestsTab">
          <result-row
            v-for="(item, index) in results"
            :key="index"
            :item="item"
            :actions-to-show="resultRowActions"
            @open="handlerOpen"
            @close="handlerClose"
            @refresh="() => onSearchHandler(pagination.currentPage)"
          />
        </template>
        <template v-else-if="isBooksTab">
          <book-result-row
            v-for="(item, index) in results"
            :key="index"
            :item="item"
            :actions-to-show="bookResultRowActions"
            @open="handlerOpen"
            @close="handlerClose"
            @refresh="() => onSearchHandler(pagination.currentPage)"
          />
        </template>
        <pagination
          v-if="
            pagination.totalItemCount > pagination.pageSize &&
              (isRequestsTab || isBooksTab)
          "
          :data="pagination"
          :page-size="pagination.pageSize"
          @pagination-go-page="onSearchHandler"
        />
      </div>
      <custom-result-not-found v-else text="No hay Información Disponible." />
    </div>
  </div>
</template>
<script>
import PageHeader from "PageHeader";
import Board from "Board";
import ActionButton from "ActionButton";
import { QTab, QTabItem } from "@/components/common/q-tabs";
import storeMixin from "@/mixin/storeGenerator";
import alertMixin from "@/mixin/alert.mixin";
import inventoryCatalogService from "@/services/api/inventorycatalog.api";
import inventoryOrderBooksService from "@/services/api/inventoryOrderBooks.api";
import TABS from "@/utils/constants/inventory/inventoryOrderbooksTabs";
import StudentsWithBooks from "./tabs/StudentsWithBooks";
import FilterManager from "FilterManager";
import CustomSeparator from "custom-separator";
import CustomResultNotFound from "custom-result-not-found";
import Pagination from "pagination";
import locationService from "@/services/api/location.api";
import academicService from "@/services/api/academicUtils.api.js";
import ResultRow from "./components/ResultRow.vue";
import BookResultRow from "./components/BookResultRow.vue";
import { name as appModuleName } from "@/modules/app/store/index";
import { mapGetters } from "vuex";
import EduEspCode from "@/utils/constants/eduEspCode";
import EduEspTextCodes from "@/utils/constants/EduEspTextCodes";
import * as bookService from "@/modules/books-requests/api";
import ACTIONS from "@/utils/constants/inventoryOrderBooksRowAction";
import BOOK_ROW_ACTIONS from "@/utils/constants/inventoryBookRowActions";

const DEFAULT_PAGE_SIZE = 5;

export default {
  name: "InventoryOrderBooks",
  components: {
    PageHeader,
    Board,
    QTab,
    QTabItem,
    ActionButton,
    StudentsWithBooks,
    FilterManager,
    CustomSeparator,
    CustomResultNotFound,
    Pagination,
    ResultRow,
    BookResultRow
  },
  mixins: [alertMixin, storeMixin],
  created() {
    this.activeTab = this.tabParam;
  },
  data: () => ({
    activeTab: TABS.Requests,
    tabKey: 0,
    loading: false,
    filter: {
      model: {
        catalog: null,
        subject: null,
        grade: null,
        status: null,
        publisher: null,
        author: null,
        readingMedium: null,
        center: null,
        municipality: null,
        school: null,
        requestCode: null,
        teacher: null,
        studentNameOrsie: null
      },
      options: {
        catalogs: [],
        subjects: [],
        statuses: [],
        grades: [],
        centers: [],
        publishers: [],
        authors: [],
        readingMediums: [],
        municipalities: [],
        schools: []
      }
    },
    pagination: {
      count: 0,
      currentPage: 1,
      pageCount: 1,
      totalItemCount: 0,
      pageSize: DEFAULT_PAGE_SIZE
    },
    results: []
  }),
  computed: {
    tabs() {
      return { ...TABS };
    },
    ...mapGetters(appModuleName, {
      isMobile: "getIsMobileDensity"
    }),
    headerPage() {
      return {
        icon: "fas fa-book-open",
        title: "Pedidos de Libros",
        routes: ["Inicio", "Libros", "Pedidos de Libros"]
      };
    },
    hasResults() {
      return Boolean(this.results?.length);
    },
    headerActions() {
      return [
        {
          text: "Regresar",
          icon: "fas fa-arrow-circle-left",
          variant: "outline-success",
          click: () => this.$router.go(-1)
        },
        {
          text: "Crear Pedido",
          icon: "fal fa-plus-circle",
          variant: "success",
          click: () =>
            this.$router.push({
              name: "inventoryOrderBooksAdd"
            })
        }
      ];
    },
    separatorText() {
      if (this.isRequestsTab) return "Resultados de las Solicitudes";
      if (this.isBooksTab) return "Resultados de Libros";
      return "";
    },
    resultRowActions() {
      return [
        ACTIONS.Info,
        ACTIONS.History,
        ACTIONS.ReceivedByMaster,
        ACTIONS.PurchaseInfo,
        ACTIONS.ViewAssignedBook,
        ACTIONS.ContinueBookRequest
      ];
    },
    bookResultRowActions() {
      return [
        BOOK_ROW_ACTIONS.AssignStudent,
        BOOK_ROW_ACTIONS.UnassignStudent,
        BOOK_ROW_ACTIONS.CustodianHistory,
        BOOK_ROW_ACTIONS.Seize,
        BOOK_ROW_ACTIONS.AdditionalInfo,
        BOOK_ROW_ACTIONS.TransferInfo
      ];
    },
    isRequestsTab() {
      return this.activeTab === TABS.Requests;
    },
    isBooksTab() {
      return this.activeTab === TABS.Books;
    },
    tabParam() {
      return Number(this.$route.query.tab ?? TABS.Requests);
    },
    canSeeTeacherFilter() {
      return (
        this.userHasPermissions("academic.books.requests.viewall") &&
        this.isRequestsTab
      );
    },
    filtersHeader() {
      return [
        {
          name: "catalog",
          component: "CustomDropDown",
          options: this.filter.options.catalogs,
          value: this.filter.model.catalog,
          placeholder: "Título del Libro",
          fieldName: "name",
          fieldKey: "id",
          class: "col-sm-6 col-md-3 ml-0 mr-0",
          clearable: true
        },
        {
          name: "subject",
          component: "CustomDropDown",
          options: this.filter.options.subjects,
          value: this.filter.model.subject,
          placeholder: "Materia",
          fieldName: "name",
          fieldKey: "id",
          class: "col-sm-6 col-md-3 ml-0 mr-0",
          clearable: true
        },
        {
          name: "grade",
          component: "CustomDropDown",
          options: this.filter.options.grades,
          value: this.filter.model.grade,
          placeholder: "Grado",
          fieldName: "name",
          fieldKey: "id",
          class: "col-sm-6 col-md-3 ml-0 mr-0",
          clearable: true
        },
        {
          name: "status",
          component: "CustomDropDown",
          options: this.filter.options.statuses,
          value: this.filter.model.status,
          placeholder: "Estatus",
          fieldName: "name",
          fieldKey: "id",
          class: "col-sm-6 col-md-3 ml-0 mr-0",
          clearable: true
        },
        {
          name: "publisher",
          label: "Casa Editorial:",
          component: "CustomDropDown",
          value: this.filter.model.publisher,
          options: this.filter.options.publishers,
          placeholder: "Seleccione",
          class: "col-12 col-sm-6 col-md-3 d-flex flex-column",
          fieldName: "name",
          fieldKey: "id",
          isAdvanced: true
        },
        {
          name: "author",
          label: "Autor:",
          component: "CustomDropDown",
          value: this.filter.model.author,
          options: this.filter.options.authors,
          placeholder: "Seleccione",
          class: "col-12 col-sm-6 col-md-3 d-flex flex-column",
          fieldName: "name",
          fieldKey: "id",
          isAdvanced: true
        },
        {
          name: "readingMedium",
          label: "Medio Lectura:",
          component: "CustomDropDown",
          value: this.filter.model.readingMedium,
          options: this.filter.options.readingMediums,
          placeholder: "Seleccione",
          class: "col-12 col-sm-6 col-md-3 d-flex flex-column",
          fieldName: "name",
          fieldKey: "id",
          isAdvanced: true
        },
        {
          name: "center",
          label: "Centro:",
          component: "CustomDropDown",
          value: this.filter.model.center,
          options: this.filter.options.centers,
          placeholder: "Seleccione",
          class: "col-12 col-sm-6 col-md-3 d-flex flex-column",
          fieldName: "name",
          fieldKey: "id",
          clearable: true,
          isAdvanced: true
        },
        {
          name: "municipality",
          label: "Municipio:",
          component: "CustomDropDown",
          value: this.filter.model.municipality,
          options: this.filter.options.municipalities,
          placeholder: "Seleccione",
          class: "col-12 col-sm-6 col-md-3 d-flex flex-column",
          fieldName: "name",
          fieldKey: "id",
          clearable: true,
          isAdvanced: true
        },
        {
          name: "school",
          label: "Escuela:",
          component: "CustomDropDown",
          value: this.filter.model.school,
          options: this.filter.options.schools,
          placeholder: "Seleccione",
          class: "col-12 col-sm-6 col-md-3 d-flex flex-column",
          fieldName: "name",
          fieldKey: "id",
          clearable: true,
          isAdvanced: true
        },
        {
          name: "requestCode",
          component: "CustomInput",
          placeholder: "Escriba Número de Solicitud",
          label: "Número de Solicitud:",
          class: "col-12 col-sm-6 col-md-3 d-flex flex-column",
          type: "text",
          isAdvanced: true,
          visible: this.isRequestsTab
        },
        {
          name: "teacher",
          component: "CustomInput",
          placeholder: "Escriba Nombre del Maestro",
          label: "Nombre del Maestro:",
          class: "col-12 col-sm-6 col-md-3 d-flex flex-column",
          type: "text",
          isAdvanced: true,
          visible: this.canSeeTeacherFilter
        },
        {
          name: "studentNameOrsie",
          component: "CustomInput",
          placeholder: "Escriba Nombre del Estudiante o Número de SIE",
          label: "Nombre del Estudiante o Número de SIE:",
          class: "col-12 col-sm-6 col-md d-flex flex-column",
          type: "text",
          isAdvanced: true,
          visible: this.isBooksTab
        }
      ];
    }
  },
  async mounted() {
    Promise.all([
      this.getGrades(),
      this.getCenters(),
      this.getStatus(),
      this.getBookCatalogs(),
      this.getSubjects(),
      this.getAuthors(),
      this.getPublishers(),
      this.getReadingMediums()
    ]);
    await this.initData();
  },
  methods: {
    async initData() {
      this.setCurrentTab(this.tabParam);
      await this.onSearchHandler();
    },
    async setCurrentTab(tab) {
      this.resetFilters();
      const sameRoute = this.tabParam === tab;
      if (sameRoute) return;

      this.activeTab = tab;
      this.results = [];
      this.getStatus();
      if (tab) this.$router.replace({ query: { tab } });
      else this.$router.replace({ name: this.$route.name });

      const tabsToReload = [TABS.Requests, TABS.Books];

      if (tabsToReload.includes(tab)) {
        await this.onSearchHandler();
      }
    },
    async onSearchHandler(currentPage = 1) {
      const {
        catalog,
        subject,
        grade,
        status,
        publisher,
        author,
        readingMedium,
        center,
        municipality,
        school,
        requestCode,
        teacher,
        studentNameOrsie
      } = this.filter.model;
      const { pageSize } = this.pagination;

      const search = this.isRequestsTab
        ? inventoryOrderBooksService.search
        : inventoryOrderBooksService.searchMyBooks;

      const { data } = await search({
        catalogId: catalog?.id,
        subjectId: subject?.id,
        gradeId: grade?.id,
        statusId: status?.id,
        publisherId: publisher?.id,
        authorId: author?.id,
        readingMediumId: readingMedium?.id,
        centerId: center?.id,
        municipalityId: municipality?.id,
        schoolId: school?.id,
        requestCode,
        teacher,
        studentNameOrsie,
        pageIndex: currentPage,
        pageSize
      });

      this.results = data.data.map(x => ({
        ...x,
        isOpen: false,
        selected: false
      }));

      this.pagination = {
        pageSize: DEFAULT_PAGE_SIZE,
        totalItemCount: data.totalItemCount,
        pageCount: data.pageCount,
        currentPage: data.currentPage,
        count: data.count
      };
    },
    async getSubjects() {
      const { data } = await academicService.getEduEsp({
        codetype: EduEspCode.CatlibSubject
      });
      this.filter.options.subjects = data;
    },
    async getBookCatalogs() {
      const { data } = await inventoryCatalogService.getKeyValue();
      this.filter.options.catalogs = data;
    },
    async getGrades() {
      const { data } = await academicService.getGrades();
      this.filter.options.grades = data;
    },
    async getStatus() {
      const fn = this.isRequestsTab
        ? bookService.getStatusList
        : inventoryCatalogService.getInventoryStatus;
      const { data } = await fn();
      this.filter.options.statuses = data;
    },
    async onCenterChange(value) {
      this.filter.model.municipality = null;
      this.filter.model.school = null;
      this.filter.options.municipalities = [];
      this.filter.options.schools = [];

      if (!value) return;

      await this.getMunicipalities();
    },
    async onMunicipalityChange(value) {
      this.filter.model.school = null;
      this.filter.options.schools = [];

      if (!value) return;

      await this.getSchools();
    },
    async getCenters() {
      const academicYearId = this.currentAcademicYear().id;
      const { data } = await locationService.getCenters({
        academicYearId
      });
      this.filter.options.centers = data;

      if (this.filter.options.centers.length == 1) {
        this.filter.model.center = this.filter.options.centers[0];
        this.getMunicipalities();
      }
    },
    async getMunicipalities() {
      const centerId = (this.filter.model.center || {}).id;

      if (!centerId) {
        return;
      }

      const academicYearId = this.currentAcademicYear().id;
      const { data } = await locationService.getMunicipalities({
        academicYearId,
        centerId
      });
      this.filter.options.municipalities = data;

      if (this.filter.options.municipalities.length == 1) {
        this.filter.model.municipality = this.filter.options.municipalities[0];
        this.getSchools();
      }
    },
    async getSchools() {
      const municipalityId = (this.filter.model.municipality || {}).id;

      if (!municipalityId) {
        return;
      }

      const academicYearId = this.currentAcademicYear().id;
      const { data } = await locationService.getSchools({
        academicYearId,
        centerId: this.filter.model.center.id,
        municipalityId
      });
      this.filter.options.schools = data;

      if (this.filter.options.schools.length == 1) {
        this.filter.model.school = this.filter.options.schools[0];
      }
    },
    async getPublishers() {
      const { data } = await bookService.getBooksPublishers();
      this.filter.options.publishers = data.filter(
        e => e.name.toUpperCase() !== EduEspTextCodes.NotAvailable
      );
    },
    async getAuthors() {
      const { data } = await bookService.getBooksAuthors();
      this.filter.options.authors = data.filter(
        e => e.name.toUpperCase() !== EduEspTextCodes.NotAvailable
      );
    },
    async getReadingMediums() {
      const { data } = await academicService.getEduEsp({
        codetype: EduEspCode.CatlibReadingmedium
      });
      this.filter.options.readingMediums = data;
    },
    async handlerOpen(item) {
      this.results
        .filter(x => x.id !== item.id && x.isOpen)
        .forEach(x => (x.isOpen = false));

      item.isOpen = true;
    },
    handlerClose(item) {
      item.isOpen = false;
    },
    resetFilters() {
      this.filter.model = {
        catalog: null,
        subject: null,
        grade: null,
        status: null,
        publisher: null,
        author: null,
        readingMedium: null,
        center: null,
        municipality: null,
        school: null,
        requestCode: null,
        teacher: null,
        studentNameOrsie: null
      };
      this.filter.options.municipalities = [];
      this.filter.options.schools = [];
    }
  },
  destroyed() {
    this.persistData();
  },
  beforeRouteEnter(_, from, next) {
    const routes = ["inventoryOrderBooksAdd", "InventoryBookDetails"];
    next(async vm => {
      if (routes.includes(from.name)) {
        vm.recoveryData();
        await vm.onSearchHandler(1);
      } else {
        vm.shouldRecovery = false;
      }
    });
  }
};
</script>
<style scoped lang="scss">
::v-deep .font-weight-bold {
  font-weight: 700 !important;
}

.actions-dropdown ::v-deep #dropdownMenuButton {
  color: #11291b !important;
}
</style>
